<template>
  <div id="orders">
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">keyboard_arrow_right</v-icon>
    </v-breadcrumbs>
    <v-container>
      <v-row>
        <v-col class="pt-3" >
          <v-card>
            <v-card-title class="grey lighten-4 title">
              <h5 class="headline">{{$t('reports.orders')}}</h5>
              <v-spacer />

              <v-btn outlined>
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-container
              class="pa-4"
            >

              <orders-chart
                :chartdata="ordersChartData"
                :options="ordersChartOption"
              />
            </v-container>
          </v-card>
        </v-col>

        <v-col class="pt-3" >
          <v-card>
            <v-card-title class="grey lighten-4  title">
              <h5 class="headline">{{$t('reports.vehicle_cost')}}</h5>
              <v-spacer />

              <v-btn outlined>
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-container
              class="pa-4"
            >

              <shipments-chart
                :chartdata="shipmentsChartDate"
                :options="ordersChartOption"
              />
            </v-container>
          </v-card>
        </v-col>

        <v-col class="pt-3" >
          <v-card>
            <v-card-title class="grey lighten-4  title">
              <h5 class="headline">{{$t('reports.orders_by_customer')}}</h5>
              <v-spacer />

              <v-btn outlined>
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-container
              class="pa-4"
            >

              <orders-by-customer
                :chartdata="ordersByCustomer"
                :options="ordersByCustomerOptions"
              />
            </v-container>
          </v-card>
        </v-col>

        <v-col class="pt-3" >
          <v-card>
            <v-card-title class="grey lighten-4  title">
              <h5 class="headline">{{$t('reports.orders_by_country')}}</h5>
              <v-spacer />

              <v-btn outlined>
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-card-title>
            <shipments-by-country />
          </v-card>
        </v-col>

        <v-col class="pt-3" >
          <v-card>
            <v-card-title class="grey lighten-4  title">
              <h5 class="headline">{{$t('reports.shipment_history')}}</h5>
              <v-spacer />

              <v-btn outlined>
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-card-title>
            <shipments-history />
          </v-card>
        </v-col>

      </v-row>
    </v-container>
  </div>

</template>

<script>

import OrdersChart from '@/components/charts/OrdersChart'
import ShipmentsChart from '@/components/charts/ShipmentsChart'
import OrdersByCustomer from '@/components/charts/OrdersByCustomer'
import ShipmentsByCountry from '@/components/charts/ShipmentsByCountry'
import ShipmentsHistory from '@/components/charts/ShipmentsHistory'

export default {
  name: 'Reports',
  data () {
    return {
      displayOrdersFilters: false,
      height: 500,
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: 'Reports', disabled: true }
      ],
      ordersItems: ['week', 'month', 'custom'],
      ordersByCustomerOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      },
      ordersChartOption: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    ordersByCustomer () {
      return {
        labels: ['Customer A', 'Customer B', 'Customer C', 'Customer D'],
        datasets: [
          {
            backgroundColor: [
              '#f85079',
              '#f87079',
              '#f89079',
              '#f8f022'
            ],
            data: [40, 20, 80, 10]
          }
        ]
      }
    },
    shipmentsChartDate () {
      return {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: '1AA1234',
            data: [40, 20, 12, 39, 10, 40, 39, 50, 40, 20, 12, 11],
            fill: false,
            borderColor: '#f87979',
            backgroundColor: '#f87979'
          },
          {
            label: '1B11234',
            data: [80, 20, 33, 9, 15, 10, 69, 24, 10, 13, 28, 33],
            fill: false,
            borderColor: '#f85079',
            backgroundColor: '#f85079'
          }
        ]
      }
    },
    ordersChartData () {
      let hideOrders = false
      let hidePackages = false

      return {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Orders',
            backgroundColor: '#f87979',
            data: [40, 20, 12, 39, 10, 40, 39, 50, 40, 20, 12, 11],
            hidden: hideOrders
          },
          {
            label: 'Packages',
            backgroundColor: '#f85079',
            data: [80, 20, 33, 9, 15, 10, 69, 24, 10, 13, 28, 33],
            hidden: hidePackages
          }
        ]
      }
    }
  },
  components: {
    OrdersChart,
    ShipmentsChart,
    OrdersByCustomer,
    ShipmentsByCountry,
    ShipmentsHistory
  }

}
</script>
